import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import CollaboratorDashboard from "@/pages/CollaboratorDashboard";
import WeeklyReportForm from "@/pages/WeeklyReportForm";
import CollaboratorSales from "@/pages/CollaboratorSales";
import TeamMap from "@/pages/TeamMap";
import Register from "@/pages/Register";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminStats from "@/pages/AdminStats";
import AdminReports from "@/pages/AdminReports";
import AdminUsers from "@/pages/AdminUsers";
import AdminMap from "@/pages/AdminMap";
import AdminSales from "@/pages/AdminSales";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/inscription" element={<Register />} />

            {/* Collaborator */}
            <Route path="/dashboard" element={<ProtectedRoute><CollaboratorDashboard /></ProtectedRoute>} />
            <Route path="/rapport" element={<ProtectedRoute><WeeklyReportForm /></ProtectedRoute>} />
            <Route path="/ventes" element={<ProtectedRoute><CollaboratorSales /></ProtectedRoute>} />
            <Route path="/equipe-carte" element={<ProtectedRoute><TeamMap /></ProtectedRoute>} />

            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/ventes" element={<ProtectedRoute adminOnly><AdminSales /></ProtectedRoute>} />
            <Route path="/admin/stats" element={<ProtectedRoute adminOnly><AdminStats /></ProtectedRoute>} />
            <Route path="/admin/rapports" element={<ProtectedRoute adminOnly><AdminReports /></ProtectedRoute>} />
            <Route path="/admin/carte" element={<ProtectedRoute adminOnly><AdminMap /></ProtectedRoute>} />
            <Route path="/admin/collaborateurs" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />

            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
